import { Link } from "react-router-dom";
import { Info } from "lucide-react";
import { Layout } from "../components/Layout";

export default function BillingCancelPage() {
  return (
    <Layout>
      <div data-testid="billing-cancel-page" className="max-w-xl mx-auto py-12">
        <div className="bg-white border border-[#E8E6E1] rounded-xl p-10 text-center">
          <div className="w-14 h-14 bg-[#FFF4E5] rounded-full flex items-center justify-center mx-auto">
            <Info className="w-8 h-8 text-[#B07020]" strokeWidth={1.5} />
          </div>
          <h1 className="mt-6 font-heading text-2xl text-[#1C211F]">Checkout cancelled</h1>
          <p className="mt-3 text-sm text-[#57605A]">
            No worries — you were not charged. You can pick a plan whenever you are ready.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/pricing"
              data-testid="cancel-back-to-pricing-btn"
              className="bg-[#2E5C50] text-white hover:bg-[#22463D] transition-colors duration-200 rounded-md px-5 py-2.5 text-sm font-medium"
            >
              Back to plans
            </Link>
            <Link
              to="/dashboard"
              data-testid="cancel-go-dashboard-btn"
              className="bg-[#F9F7F4] text-[#1C211F] hover:bg-[#E8E6E1] transition-colors duration-200 rounded-md px-5 py-2.5 text-sm font-medium border border-[#E8E6E1]"
            >
              Go to dashboard
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}
